import { List, Record } from 'immutable';
import { schema } from 'normalizr';

import { cameraInterfaceControllerSchema } from '@sophocles/entities/CameraInterfaceController';
import { intrusionSensorConfigurationSchema } from '@sophocles/entities/IntrusionSensorConfiguration';
import { radioSchema } from '@sophocles/entities/Radio';
import { relaySchema } from '@sophocles/entities/Relay';
import { relayControllerFirmwareVersionSchema } from '@sophocles/entities/RelayControllerFirmwareVersion';
import { smartlinkModelSchema } from '@sophocles/entities/SmartlinkModel';

export const SmartlinkUnit = new Record({
  id: undefined,
  cic: null,
  name: '',
  number_of_relays: undefined,
  schedules_per_relay: undefined,
  supports_day_of_week_schedules: undefined,
  site: undefined,
  last_status_received_at: null,
  radio: null,
  model: null,
  client_device_names: '',
  relays: List(),
  intrusion_sensor_configuration: null,
  firmware_version: null,
  relay_monitor: null,
});

export const smartlinkUnitSchema = new schema.Entity('smartlinkUnits', {
  radio: radioSchema,
  cic: cameraInterfaceControllerSchema,
  relays: [relaySchema],
  model: smartlinkModelSchema,
  intrusion_sensor_configuration: intrusionSensorConfigurationSchema,
  firmware_version: relayControllerFirmwareVersionSchema,
});
